package com.htmlagent.site.components.widgets

import androidx.compose.runtime.Composable
import com.htmlagent.shared.UiLocale
import com.htmlagent.site.theme.Tokens
import com.htmlagent.site.theme.Tracking
import com.htmlagent.site.theme.Weight
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

/**
 * A language written as its two-letter code, for the button that switches to it.
 *
 * [Icons] has no glyph for a language, and a globe would say "the world" rather than which
 * language it changes to; the code is what the person recognizes. It is `aria-hidden` because
 * the button that contains it already carries the name.
 *
 * Both the workspace rail and the landing bar show one, which is why it is a widget: the same
 * control drawn twice from two copies would drift the first time either is touched.
 */
@Composable
fun LocaleCode(locale: UiLocale) {
    Span(
        Modifier
            .fontSize(Tokens.textXs.value())
            .styleModifier {
                property("font-weight", "${Weight.Bold}")
                property("letter-spacing", Tracking.Loose)
            }
            .toAttrs { attr("aria-hidden", "true") },
    ) {
        Text(locale.tag.uppercase())
    }
}
